
import * as _ from 'lodash';
import { Map } from 'ol';
import {
  MapEngineOptions, BaseEngine, EngineType, FieldsInterface, WGisAlignement,
  WGisServiceInterface, WGisToolOption, WGisFeatureInfo, WGisFeatureInterface
} from './wgis.utils';
import { WGisBaseTool } from './wgis.tool';
import Feature from 'ol/Feature';
import Layer from 'ol/layer/Layer';
import { reject } from 'q';
import BaseLayer from 'ol/layer/Base';
import { Size } from 'ol/size';


export abstract class WGisEngine implements BaseEngine {
  public isMaster = false;
  public isSelection = false;
  public isBase = false;
  public isEdit = false;
  public type: EngineType = undefined;
  public zorder: number;
  public isOn = true;
  public selectable = false;
  public editable = false;
  public opacity = 1.0;
  public title: '';
  public name: '';
  public url = undefined;
  public engineId = 0;
  public noDispName: string[];
  public icon: string;
  public path: string;
  public extension: string;
  public size: Size;
  public bbox: [number,number,number,number];


  // per wms
  public attributions?: string;
  public crossOrigin?: string;
  public hidpi?: boolean;
  public serverType?: string;
  public params?: { [key: string]: any };
  public projection?: string;
  public ratio?: number;
  public resolutions?: number[];

  protected switched = false;
  protected service: WGisServiceInterface;
  protected oLayer: Layer = null;
  protected switcher: WGisBaseTool = undefined;
  // param Object options
  /**
   * Estrae gli attributi da un oggetto per clonare una feature
   * eventuali strutture innestate non sono clonate
   *
   * @param objistance  una oggetto qualsiasi
   */
  public static extract_fileds(objistance: any): FieldsInterface {
    const out: FieldsInterface = {};
    for (const field in objistance) {
      if (_.isNumber(objistance[field])) {
        out[field] = objistance[field];
      } else if (_.isString(objistance[field])) {
        out[field] = objistance[field];
      } else if (objistance[field] === undefined) {
        out[field] = objistance[field];
      }
    }
    return out;
  }


  constructor(options: MapEngineOptions, wgisService: WGisServiceInterface) {
    this.service = wgisService;
    this.engineId = this.service.sequence();
    _.extend(this, options);
    _.defaults(this, {
      isMaster: false,
      unselectable: false,
      isBase: false,
      noDispName: ['ID', 'IDXSHAPE', 'GEOCODICE', 'SHAPE', 'OBJECTID', 'LINKCATNEW'],
    });
  }

  /**
   * Separato il metodo per permettere la gestione di engine con diversi layers
   */
  protected addLayers() {
    this.oLayer.setVisible(this.isOn);
    this.service.addLayer(this.oLayer, this.zorder);
  }

  /**
   * registra i layer e predispone gli handler della gui per la sua gestione
   */
  registerLayer(): Promise<Map> {
    return new Promise((resolve, reject) => {

      this.service.pMap.then((map: Map) => {
        if (this.isOn === undefined) {
          this.isOn = true;
        }
        this.addLayers();

        if (this.isBase) {
          this.service.wgisBaseOn.subscribe((engine: BaseEngine) => {
            if (engine !== this) {
              this.turn(false);
            }
          });
          let tit: string = this.name ? this.name : this.title;
          tit = tit ? tit : this.type;
          const opt: WGisToolOption = {
            wgisservice: this.service,
            icon: this.icon ? this.icon : 'fa-layer-group',
            active: true,
            trigger: () => {
              this.turn(true);
              // this.turn(!this.isOn);
            },
            title: 'display ' + tit,
          };
          this.switcher = new WGisBaseTool(opt);
          // if (this.isOn) {
          //   this.switcher.hide();
          // } else {
          //   this.switcher.show();
          // }
          // this.service.addTool({ alignment: WGisAlignement.midLeft, tool: this.switcher });
        }
        resolve(map);
      });
    });
  }

  show() {
    this.turn(this.isOn);

  }

  hide() {
    if (this.isBase && this.switcher) {
      this.switcher.hide();
    }
    this.oLayer.setVisible(false);
  }

  protected turnLayers(on: boolean): void {
    if (this.oLayer === undefined) {
      return;
    }
    this.oLayer.setVisible(on);
  }

  public turn(on: boolean): void {
    if (this.oLayer === undefined) {
      return;
    }
    this.turnLayers(on);
    this.isOn = on;
    if (this.isOn) {
      if (this.isBase) {
        this.service.wgisBaseOn.emit(this);
        if (this.switcher) {
          this.switcher.hide();
        }
      }
    } else {
      if (this.isBase && this.switcher) {
        this.switcher.show();
      }
    }
  }



  /**
   * onLineStatusListener react to online status only used in  mobile apps
   */
  onLineStatusListener(evt: any) {
    if (evt.online) {
      if (this.switched && !this.isOn) {
        this.switched = false;
        this.turn(true);
      }
    } else {
      if (this.isOn) {
        this.switched = true;
        this.turn(false);
      }
    }
  }

  isFieldDisplayble(name: string): boolean {
    if (typeof name === 'string') {
      return (_.indexOf(this.noDispName, name) > -1);
    } else { return false; }
  }

  registerloadingEvents() {
    this.oLayer.on('loadstart', (evt) => {
      this.startloading();
    });
    this.oLayer.on('loadend', (evt) => {

      this.stoploading();
    });
  }

  // default behavier using jast 1 layer overide when nedded
  getLayers(): Layer[] {
    if (this.oLayer !== null) {
      return [this.oLayer];
    } else { return []; }
  }

  stoploading() {
    this.service.stopWaiting();
  }

  startloading() {
    this.service.startWaiting();
  }


  getUrl(): string {
    return (typeof this.url === 'string') ? this.url : 'engine/';
  }

  getOpacity(): number {
    return (this.opacity * 100);
  }

  /**
   *
   * param val
   */
  setOpacity(val: number) {
    this.opacity = (val / 100);
    if (this.oLayer !== null) {
      this.oLayer.setOpacity(this.opacity);
    }
  }

  /**
   *
   * returns
   */
  getMap() {
    return this.oLayer;
  }


  /**
   *
   * nosideeffects
   */
  getLayer() {
    return this.oLayer;
  }


  getMapName() {
    return this.name ? this.name : '';
  }
  /**
   * return String
   * nosideeffects
   */
  getMapKey() {
    return this.engineId;
  }

  /**
   * return String
   * nosideeffects
   */
  getMapTitle(): string {
    return this.title ? this.title : '';
  }

  // OVERIDE ME
  // crea una feature a aggiunge istanza di OikosMngmt  con proprieta da overide
  abstract buildFeature(geometry: string, attribute: FieldsInterface, info: WGisFeatureInfo): WGisFeatureInterface;
  abstract feature_factory(fields: FieldsInterface, wkt: string, projection?: string): WGisFeatureInterface;
  abstract saveSelection(): void;
  abstract clearSelection(): void;
  abstract getSelection(): void;
  abstract addFeatureToSelection(feature: Feature);
  abstract removeFeatureFromSelection(feature: Feature);
}
